import React, { PropsWithChildren } from 'react';
import styles from './filed-block.module.scss';
import clsx from 'clsx';

interface Props {
    error?: boolean;
    id?: string;
    className?: string;
}
export const FieldBlock: React.FC<PropsWithChildren<Props>> = ({
    children,
    error,
    id,
    className,
}) =>
    <div
        className={
            clsx(
                styles.fieldBlock,
                error && styles.error,
                className,
            )
        }
        id={id}>{children}</div>;
